import React from "react";
import themePropTypes from "../theme-prop-types";

const Chip = ({
  label,
  onLabelClick,
  onDismissClick,
  dismissable,
  isSelected
}) => (
  <div
    className={`chip-root-web-sdk ${isSelected ? "selected" : ""} ${
      dismissable ? "not-clicable" : ""
    }`}
    tabIndex='0'
    role='button'
    onClick={onLabelClick}
    onKeyPress={e => {
      if (e.key === "Enter" || e.key === " ") {
        onLabelClick(e);
      }
    }}
  >
    <div className='chip-container-web-sdk'>
      <div className='chip-row-web-sdk'>
        <div className='chip-label-web-sdk'>{label}</div>
        {dismissable && (
          <div
            onClick={onDismissClick}
            onKeyPress={e => {
              if (e.key === "Enter" || e.key === " ") {
                onDismissClick(e);
              }
            }}
            className='chip-icon-web-sdk'
            aria-label={`Dismiss ${label}`}
            tabIndex='0'
            role='button'
          />
        )}
      </div>
    </div>
  </div>
);

Chip.propTypes = themePropTypes.chip;

export default Chip;
